import Vue from 'vue';
import Address from '@bit/duncank.work.forms.address';
import webdata from '@bit/duncank.work.utils.webdata';
import priceformat from '@bit/duncank.work.utils.priceformat';
import linkify from '@bit/duncank.work.utils.linkify';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import i18n from './i18n';

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['icon'];
global.router = router;
global.store = store;

// Global Mixins
Vue.mixin(webdata);

Vue.filter('priceformat', priceformat);
Vue.filter('linkify', linkify);

Vue.use(Address, { key: 'AIzaSyB3kNVSLcT6zIwa4PErITKPoBo0rJAA3LM' });
Vue.use(VueGoogleMaps, { load: { key: 'AIzaSyB3kNVSLcT6zIwa4PErITKPoBo0rJAA3LM', libraries: 'places' } });
Vue.use(VueMeta, {
    keyName: 'meta',
    refreshOnceOnNavigation: true,
});

// Filters
new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount('#app');
